var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
class Rating extends React.Component {
    constructor() {
        super(...arguments);
        this.getStartWidth = (rating, idx) => {
            const { halfFloor } = this.props;
            let showRating = rating;
            if (halfFloor) {
                const floorNum = Math.floor(rating);
                const ceilNum = Math.ceil(rating);
                if (rating + 0.5 < ceilNum) {
                    showRating = floorNum;
                }
                else if (rating + 0.5 > ceilNum) {
                    showRating = floorNum + 0.5; // 半
                }
            }
            const floor = Math.floor(showRating);
            const currentIdx = idx + 1;
            if (idx + 1 <= floor) {
                return '100%';
            }
            else if (currentIdx > showRating && currentIdx < showRating + 1) {
                return `${((showRating - floor) * 100).toFixed(0)}%`;
            }
            else {
                return '0';
            }
        };
    }
    render() {
        const _a = this.props, { rating, halfFloor, actionLeft, actionRight, maxStars, className, iconSize, iconStyle, color, bgColor, onItemClick } = _a, restProps = __rest(_a, ["rating", "halfFloor", "actionLeft", "actionRight", "maxStars", "className", "iconSize", "iconStyle", "color", "bgColor", "onItemClick"]);
        let max = maxStars;
        return (<div className={classnames(`cfm_rating`, className)} {...restProps}>
        {actionLeft ? <span className='cfm_rating_left'>{actionLeft}</span> : null}
        {[...new Array(max)].map((_ig, idx) => (<span key={idx} className={'cfm_rating_bg_start'} onClick={() => { onItemClick && onItemClick(idx + 1, idx); }}>
            <Icon type='ratingStar' size={iconSize} color={bgColor} style={iconStyle}/>
            <span className='cfm_rating_front_start' style={{
            width: this.getStartWidth(rating, idx)
        }}>
              <Icon type='ratingStar' size={iconSize} color={color} style={iconStyle}/>
            </span>
          </span>))}
        {actionRight ? <span className='cfm_rating_right'>{actionRight}</span> : null}
      </div>);
    }
}
Rating.defaultProps = {
    rating: 0,
    maxStars: 5,
    iconSize: 'sm',
    color: '#FA4946',
    bgColor: '#fff0f0',
};
export default Rating;



// WEBPACK FOOTER //
// ./components/rating/index.tsx